export default function Button ({
    name, className = 'text-4xl', onClick
}){
    return <span className={`material-symbols-rounded ${className}`} onClick={onClick}>
        {name}
    </span>
}